import AbstractChatMessage from './AbstractChatMessage'
import { MessageTypes } from '@/constants/chat/MessageTypes'

export default class JobMarkedDoneChatMessage extends AbstractChatMessage {
  type = MessageTypes.JOB_MARK_IS_DONE
  isPayed: boolean
  markIsDone: boolean
  initiator?: string

  constructor(data: LX.JobMarkedDoneChatMessage) {
    super(data)
    this.body = null
    this.isPayed = data.body.is_payed
    this.markIsDone = data.body.mark_is_done
    this.initiator = data.body.mark_not_done_initiator
  }

  static fromServer(data: LX.JobMarkedDoneChatMessage) {
    return new JobMarkedDoneChatMessage(data)
  }

  getShortMessage() {
    return 'Talent marked job as complete'
  }
}
